import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import Firebase, { FirebaseContext } from './components/Firebase';
import 'bootstrap/dist/css/bootstrap.css';

ReactDOM.render(
    <Router onUpdate={() => window.scrollTo(0, 0)}>
        <FirebaseContext.Provider value={new Firebase()}>
            <App />
            <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent"></meta>
            <script
                src="https://code.jquery.com/jquery-3.3.1.min.js"
                integrity="sha256-FgpCb/KJQlLNfOu91ta32o/NMZxltwRo8QtmkMRdAu8="
                crossOrigin="anonymous"></script>
            <script src="https://api.trello.com/1/client.js?key=0f801328c5eb1a3e5afd86b655b17534"></script>
        </FirebaseContext.Provider>
        <Route render={() => window.scrollTo(0, 0)}></Route>
    </Router>,
    document.getElementById('root'));


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
